// Direction backward trigger
// ----------------------------------------------------------------

import $ from 'jquery';
import { stepBack } from './step-back';

const directionBackwardTrigger  = $('.js-formDirectionBackwardTrigger');

$(directionBackwardTrigger).on('click', function() {
    var fieldset = $(this).closest('fieldset');
    stepBack(fieldset);
});

